import { RouterProvider } from 'react-router-dom'
import { router } from '@/app/router'
import ErrorBoundary from '@/shared/components/feedback/ErrorBoundary'
import DatabaseWakingNotice from '@/shared/components/ui/DatabaseWakingNotice'

export default function App() {
  return (
    <ErrorBoundary>
      <RouterProvider router={router} />
      <DatabaseWakingNotice />
    </ErrorBoundary>
  )
}
